<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/product-lines"
      title="Lista linii produktów"
      :numeral_text="['linia produktów', 'linie produktów', 'linii produktów']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
